import PropTypes from 'prop-types';

const FootballPitch = ({ size }) => {
    if (size === 'large') {
        return (
            <svg
                width="1000"
                height="800"
                viewBox="0 0 1000 800"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_2100_51345)">
                    <path
                        d="M85.3224 41H912.678L1132 1474H-134L85.3224 41Z"
                        fill="currentColor"
                        fillOpacity="0.05"
                    />
                    <path
                        opacity="0.6"
                        d="M568 59V11H432V59H568ZM925 497H635.948C635.982 498.163 636 499.33 636 500.5C636 570.916 574.663 628 499 628C423.337 628 362 570.916 362 500.5C362 499.33 362.018 498.163 362.052 497H73C72.9843 497 72.9687 496.998 72.9531 496.997L-47.7324 1457H1045.73L925.046 496.997C925.031 496.998 925.015 497 925 497ZM364.053 497C364.018 498.163 364 499.33 364 500.5C364 569.679 424.304 626 499 626C573.696 626 634 569.679 634 500.5C634 499.33 633.982 498.163 633.947 497H364.053ZM172.982 61C172.626 71.3517 166.759 80.6321 157.874 87.4043C148.701 94.3955 136.242 98.7781 123.017 98.9922C123.007 98.9923 122.998 98.9903 122.988 98.9902L73.2051 495H362.128C365.223 427.135 425.317 373 499 373C572.683 373 632.777 427.135 635.872 495H924.795L875.008 98.9658C862.146 98.5577 850.073 94.2233 841.126 87.4043C832.241 80.6321 826.374 71.3517 826.018 61H750.226L770 236H596.436C572.583 261.804 538.21 278 500 278C461.79 278 427.417 261.804 403.564 236H228L247.774 61H172.982ZM499 375C426.294 375 367.225 428.361 364.13 495H633.87C630.775 428.361 571.706 375 499 375ZM406.308 236C429.735 260.617 463.041 276 500 276C536.959 276 570.265 260.617 593.692 236H406.308ZM230.238 234H767.762L748.213 61H616.138L620 117H378L381.862 61H249.787L230.238 234ZM380.143 115H617.857L614.134 61H383.866L380.143 115ZM123.24 96.9854C135.966 96.7257 147.906 92.4873 156.662 85.8135C165.184 79.3184 170.626 70.5781 170.981 61H127.765L123.24 96.9854ZM828.019 61C828.374 70.5781 833.816 79.3184 842.338 85.8135C850.863 92.3113 862.406 96.5018 874.755 96.958L870.235 61H828.019ZM876.832 97.4375C876.941 97.6005 877.003 97.797 877 98.0078C876.998 98.118 876.978 98.2236 876.943 98.3223L1048 1459H-50L126 59H428V7H572V59H872L876.832 97.4375Z"
                        fill="currentColor"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_2100_51345">
                        <rect width="1000" height="800" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }

    if (size === 'small') {
        return (
            <svg
                width="698"
                height="800"
                viewBox="0 0 698 800"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_2100_53103)">
                    <path
                        d="M106.713 28H591.287L725 869H-27L106.713 28Z"
                        fill="currentColor"
                        fillOpacity="0.05"
                    />
                    <path
                        opacity="0.6"
                        d="M392.113 38H567.772L671 860H27L97.8291 295.983C97.3584 295.902 97 295.494 97 295C97 294.448 97.4477 294 98 294H98.0791L130.228 38H305.932V7H392.113V38ZM29.2666 858H668.733L598.156 296H427.982C427.993 296.499 428 296.999 428 297.5C428 339.198 392.183 373 348 373C303.817 373 268 339.198 268 297.5C268 296.999 268.007 296.499 268.018 296H99.8438L29.2666 858ZM270.018 296C270.007 296.499 270 296.999 270 297.5C270 337.985 304.811 371 348 371C391.189 371 426 337.985 426 297.5C426 296.999 425.993 296.499 425.982 296H270.018ZM159.972 40C159.632 46.5072 155.996 52.0957 150.576 56.1123C144.905 60.3148 137.231 62.8444 129.104 62.9971L100.095 294H268.086C270.024 253.927 305.06 222 348 222C390.94 222 425.977 253.927 427.914 294H597.905L568.896 62.9971C554.112 62.6969 540.671 53.2983 540.026 40H496.455L508 142H405.999C405.999 142.245 405.91 142.491 405.729 142.684C391.731 157.621 371.496 167 349 167C326.504 167 306.269 157.621 292.271 142.684C292.09 142.491 292.001 142.245 292.001 142H189L200.545 40H159.972ZM348 224C306.063 224 272.026 255.129 270.089 294H425.911C423.974 255.129 389.937 224 348 224ZM294.379 142C307.98 156.144 327.414 165 349 165C370.586 165 390.02 156.144 403.621 142H294.379ZM191.239 140H505.761L494.442 40H416.802L419 73H278L280.198 40H202.558L191.239 140ZM280.137 71H416.863L414.798 40H282.202L280.137 71ZM129.355 60.9902C137.003 60.7906 144.148 58.3862 149.385 54.5059C154.412 50.7809 157.632 45.7412 157.969 40H131.992L129.355 60.9902ZM542.029 40C542.675 51.7309 554.618 60.587 568.644 60.9893L566.008 40H542.029ZM309.932 38H388.113V11H309.932V38Z"
                        fill="currentColor"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_2100_53103">
                        <rect width="698" height="800" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
};

FootballPitch.propTypes = {
    size: PropTypes.oneOf(['small', 'large'])
};

FootballPitch.defaultProps = {
    size: 'large'
};

export default FootballPitch;
